import t from 'react-translate';
import { useEffect, useState } from 'react';

const TOTAL_SECONDS = 8;

const CountdownDisplay = () => {
  const [count, setCount] = useState(TOTAL_SECONDS);

  useEffect(() => {
    if (count === 0) {
      return undefined;
    }
    const timer = setTimeout(() => setCount((prevCount) => prevCount - 1), 1000);
    return () => clearTimeout(timer);
  }, [count]);

  return (
    <div className='d-flex'>
      <p className='mb-0 text-regular text-gray-1'>
        {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.RECORDING_STARTS()}
      </p>
      <p className='mb-0 text-regular text-gray-1 ml-1 font-weight-bolder'>{count}</p>
    </div>
  );
};

export default CountdownDisplay;
